export const splitCandidateName = (fullName?: string | null) => {
  const trimmed = fullName?.trim() ?? ""

  if (!trimmed) {
    return { firstName: "", lastName: "" }
  }

  const [firstName, ...rest] = trimmed.split(/\s+/)

  return {
    firstName,
    lastName: rest.join(" "),
  }
}
